(function () {
  var trigger = document.getElementById('infinite-scroll-trigger');
  var loader = document.getElementById('infinite-scroll-loader');
  var productList = document.querySelector('.product-list');

  if (!trigger || !productList) return;

  var nextPageUrl = trigger.dataset.nextPage;
  var loading = false;

  if (!nextPageUrl) {
    trigger.remove();
    return;
  }

  // Force-reveal any cards stuck by stagger animation
  function revealCards(container) {
    container.querySelectorAll('[reveal-on-scroll]').forEach(function(el) {
      el.removeAttribute('reveal-on-scroll');
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.transition = 'opacity 0.3s ease';
      el.setAttribute('revealed', '');
    });
    // Also handle any wrapper elements with is-hidden or opacity:0
    container.querySelectorAll('product-card').forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.removeAttribute('reveal-on-scroll');
      el.setAttribute('revealed', '');
    });
  }

  function loadMore() {
    if (loading || !nextPageUrl) return;
    loading = true;
    if (loader) loader.style.display = 'block';

    fetch(nextPageUrl)
      .then(function(res) { return res.text(); })
      .then(function(text) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'text/html');

        var newList = doc.querySelector('.product-list');
        if (newList) {
          // Strip reveal-on-scroll from fetched HTML before injecting
          newList.querySelectorAll('[reveal-on-scroll]').forEach(function(el) {
            el.removeAttribute('reveal-on-scroll');
            el.setAttribute('revealed', '');
          });

          // Inject each product card
          Array.from(newList.children).forEach(function(card) {
            if (card.tagName) {
              card.removeAttribute('reveal-on-scroll');
              card.setAttribute('revealed', '');
              productList.insertAdjacentHTML('beforeend', card.outerHTML);
            }
          });

          // Force reveal all newly added cards
          revealCards(productList);
        }

        // Update next page URL
        var newTrigger = doc.getElementById('infinite-scroll-trigger');
        nextPageUrl = newTrigger ? newTrigger.dataset.nextPage : null;

        if (!nextPageUrl) {
          observer.disconnect();
          if (trigger) trigger.remove();
          if (loader) loader.remove();
        }
      })
      .catch(function(e) {
        console.error('Infinite scroll error:', e);
      })
      .finally(function() {
        if (loader) loader.style.display = 'none';
        loading = false;
      });
  }

  var observer = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting) {
      loadMore();
    }
  }, { rootMargin: '600px' });

  observer.observe(trigger);
})();
